import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrResponsiveCategoryNavigationComponent } from 'src/app/customer-libs/kn-br-navigation/components/kn-br-category-navigation/kn-br-responsive-category-navigation/kn-br-responsive-category-navigation.component';
import { IconComponent, GenericLinkComponent } from '@spartacus/storefront';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-responsive-category-navigation',
    templateUrl: './sloan-responsive-category-navigation.component.html',
    imports: [IconComponent, NgTemplateOutlet, GenericLinkComponent, AsyncPipe]
})
export class SloanResponsiveCategoryNavigationComponent extends KnBrResponsiveCategoryNavigationComponent {
  constructor(protected modalService: NgbModal) {
    super(modalService);
  }
}
